import React from "react";
import { Phone, Mail, Globe, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/constants/brand";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Why Infolocus", href: "#why" },
  { label: "Process", href: "#process" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

const SERVICES_LINKS = [
  { label: "Enterprise SaaS", href: "#services" },
  { label: "Agentic AI Workflow Automation", href: "#services" },
  { label: "Data Management", href: "#services" },
  { label: "Digital Marketing Suite", href: "#services" },
];

export const Footer = () => {
  const scrollTo = (e, id) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#0F1846] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-3">
              <img
                src={BRAND.logoUrl}
                alt="Infolocus"
                className="h-10 w-auto object-contain"
                style={{ filter: "brightness(0) invert(1)" }}
                data-testid="footer-logo-image"
              />
            </div>
            <p className="mt-6 text-base leading-relaxed text-white/70 max-w-md">
              {BRAND.slogan}. We help Indian SMEs deploy enterprise SaaS, agentic
              AI, modern data infrastructure and a full‑stack growth practice — under
              one accountable partner.
            </p>

            <div className="mt-8 space-y-3 text-sm">
              <a
                href={`tel:${BRAND.phone.replace(/[^+\d]/g, "")}`}
                data-testid="footer-phone"
                className="inline-flex items-center gap-3 text-white/85 hover:text-white"
              >
                <Phone className="h-4 w-4 text-[#7AA0FF]" /> {BRAND.phone}
              </a>
              <br />
              <a
                href={`mailto:${BRAND.emailPublic}`}
                data-testid="footer-email"
                className="inline-flex items-center gap-3 text-white/85 hover:text-white"
              >
                <Mail className="h-4 w-4 text-[#7AA0FF]" /> {BRAND.emailPublic}
              </a>
              <br />
              <a
                href={BRAND.websiteUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-website"
                className="inline-flex items-center gap-3 text-white/85 hover:text-white"
              >
                <Globe className="h-4 w-4 text-[#7AA0FF]" /> {BRAND.website}
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="uppercase text-[11px] tracking-[0.22em] font-bold text-[#7AA0FF]">
              Explore
            </p>
            <ul className="mt-5 space-y-3">
              {LINKS.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    onClick={(e) => scrollTo(e, l.href)}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-white/80 hover:text-white inline-flex items-center gap-1"
                  >
                    {l.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-60" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="uppercase text-[11px] tracking-[0.22em] font-bold text-[#7AA0FF]">
              Services
            </p>
            <ul className="mt-5 space-y-3">
              {SERVICES_LINKS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    onClick={(e) => scrollTo(e, s.href)}
                    data-testid={`footer-service-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-white/80 hover:text-white"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <p data-testid="footer-legal-name" className="text-xs md:text-sm text-white/60">
            © {year} {BRAND.legalName}. All rights reserved.
          </p>
          <p className="text-xs text-white/50">
            CIN & registered office details available on request.
          </p>
        </div>
      </div>
    </footer>
  );
};
